// i18n area 'apps' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.sv-SE.meta.json.
import type { enUS } from './apps'

export const svSE: typeof enUS = {
  apps: {
    title: 'Appar',
    create: 'Skapa app',
    createTitle: 'Skapa app',
    editTitle: 'Redigera app',
    name: 'Namn',
    nameHint: 'DNS-1123, unikt inom scopet — oföränderligt efter skapandet.',
    node: 'Nod',
    nodeHint: 'Medlemsnoden som betjänar den — explicit placement (schedulern kommer senare).',
    image: 'Avbild',
    editImageHint: 'En ny referens löses om via förteckningen — pin-/rollback-gesten.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digesten flyttar sig bara på kommando.',
    policyTrackingHint: 'Automatisk rolling när en refresh flyttar branchen.',
    archMovePolicy: 'Cross-arch-flytt',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Vad som händer om appen flyttas till en nod med en annan arkitektur: refuse avvisar flytten, reresolve löser om lockfilen från branchen på den nya archen — innehållet ändras, och svaret namnger digest-ändringen.',
    network: 'Nätverk',
    networkHint: 'Untagged L3-anslutning: ett logiskt fabric-nätverk (rekommenderat — gateway/DNS från dess enda källa), ett overlay, eller en naken host-bridge (avrådes).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host-bridge:',
    ipAssignment: 'IP-tilldelning',
    ipStatic: 'Statisk',
    ipAuto: 'Automatisk (IPAM)',
    ipAssignmentHint_static: 'Adressen ger du, nu.',
    ipAssignmentHint_auto: 'IPAM väljer en ledig adress ur nätets TVirt-reserverade range.',
    bridgeDiscouraged: 'Naken host-bridge — AVRÅDES: TVirt vet ingenting om dess adressering, så gateway och DNS måste anges för hand. Den rekommenderade vägen är ett logiskt fabric-nätverk.',
    ip: 'IP',
    ipHint: 'Statisk IPv4 inuti anslutningens subnät.',
    ipCidrHint: 'I CIDR-form på en naken bridge (t.ex. 192.168.1.10/24) — det finns inget att härleda prefixet från.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manuell — en naken bridge härleder ingenting.',
    dnsServers: 'DNS-servrar',
    dnsManualHint: 'Manuella, kommaseparerade — minst en.',
    rootKind: 'Root',
    rootEphemeral: 'efemär',
    rootPersistent: 'persistent',
    rootEphemeralHint: 'Återskapas från avbilden vid varje omskapande; bor på klustrets efemära storage.',
    rootEphemeralHintNamed: 'Återskapas från avbilden vid varje omskapande; bor på klustrets efemära storage ({name}).',
    rootPersistentHint: 'Överlever omstarter; bor på den storage du väljer.',
    rootStorage: 'Root-storage',
    editRootStorageHint: 'Rooten renderas om på den nya poolen — befintliga data flyttar sig INTE av sig själva.',
    volumes: 'Volymer',
    volumeAdd: 'Lägg till volym',
    volumeName: 'Namn',
    volumeMountPath: 'Mount-sökväg',
    volumeKind: 'Typ',
    volumeStorage: 'Storage',
    devices: 'Enheter',
    deviceClassHint: 'Man ber om en KLASS (en gpu-device- eller usb-device-tagg), aldrig en bestämd enhet: den angivna noden måste ha en som är märkt för Apps. Flera Apps kan använda samma enhet — en container delar den, den tar den inte från värden.',
    deviceSlot: 'Slot',
    deviceTag: 'Tagg',
    deviceValue: 'Klass',
    deviceUnresolved: 'inget löses just nu',
    noDeviceTags: 'Ingen tagg av typen gpu-device eller usb-device ännu: skapa en och tilldela den till enheterna som är märkta för Apps.',
    env: 'Miljö',
    envHint: 'En NYCKEL=värde per rad.',
    secretEnvTitle: 'Hemliga variabler',
    secretEnvNotice: 'Ett hemligt värde kommer aldrig tillbaka från API:et: ingen läser det igen, inte ens den som skrev det. I checkpointen färdas det förseglat med masterpassen, så en återställning utan masterpassen ber om att det skrivs in på nytt.',
    secretEnvPromote: 'Gör en av variablerna som skrivits ovan hemlig:',
    secretEnvAdd: 'Lägg till hemlig variabel',
    secretEnvName: 'Namn',
    secretEnvValue: 'Värde',
    secretEnvKept: 'bevarat — lämna tomt för att låta det vara oförändrat',
    secretEnvWithdrawWarning: 'För att sluta behandla som hemlig en variabel som redan är det, skriv ett nytt värde till den: att bara ta bort markeringen vore ett sätt att LÄSA det som aldrig lämnar storen. Att ta bort variabeln raderar den däremot.',
    secretEnvChip: 'hemlig',
    startNow: 'Starta direkt (annars föds appen stoppad)',
    deletePersistentIntro: 'Den här appen har persistenta data — välj vad som ska hända med dem:',
    deleteKeepData: 'Behåll datan (katalogerna blir kvar på sina storage, föräldralösa)',
    deletePurgeData: 'Radera även datan',
    phase: 'Fas',
    phase_running: 'Körs',
    phase_stopped: 'Stoppad',
    phase_error: 'Fel',
    phase_unknown: 'Okänd',
    desiredState: 'Önskat',
    wantedRunning: 'körande',
    wantedStopped: 'stoppad',
    start: 'Starta',
    stop: 'Stoppa',
    restart: 'Starta om',
    refreshImage: 'Uppdatera avbilden (adoptera den nya @current)',
    logs: 'Logg',
    logsTitle: 'Logg',
    logsEmpty: 'Ingen output fångad.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Appen körs inte — ett shell behöver en levande container. Dess loggar kan läsas i alla tillstånd.',
    shellConnect: 'Anslut',
    shellDisconnect: 'Koppla från',
    shellExited: 'Sessionen avslutades med exit-kod {code}.',
    shellEndedWithoutStatus: 'Sessionen avslutades utan exit-status: {reason}',
    shellRevoked: 'Sessionens ticket är inte längre giltig — den gick ut, eller inloggningen som öppnade den återkallades.',
    shellHint: 'Klicka i den svarta rutan och skriv: tangenterna går till containern. Ctrl+C och pilarna fungerar; exit stänger shellet.',
    shellStatus: {
      connecting: 'Ansluter…',
      connected: 'Ansluten',
      ended: 'Avslutad'
    },
    deleteRunningError: '{name} är önskad körande — stoppa den först.',
    tabs: {
      general: 'Allmänt',
      image: 'Avbild',
      network: 'Nätverk',
      storage: 'Storage',
      devices: 'Enheter',
      observed: 'Observerat'
    },
    attachment: 'Anslutning',
    runningDigest: 'Körande digest',
    lastError: 'Senaste fel',
    reportObservedAt: 'Workerns senaste rapport',
    desiredStateLock: 'Styrs av åtgärderna Starta/Stoppa — aldrig en direkt ändring.',
    ipEditDisabledHint: 'Kan bara ändras med statisk tilldelning.',
    derivedFromNetworkHint: 'Härlett från nätets enda källa — manuellt bara på naken bridge med statisk IP.',
    ephemeralUnset: 'inte konfigurerad',
    ephemeralMissing: 'Appernas efemära storage är inte konfigurerad — att skapa en app med efemära delar (root eller volymer) avvisas tills du sätter den.',
    ephemeralCurrent: 'Appernas efemära storage: {name}',
    ephemeralMissingCreate: 'Den här appen har efemära delar men appernas efemära storage är inte satt — skapandet kommer att avvisas. Sätt den först från bannern på App-sidan.',
    setEphemeral: 'Sätt efemär storage',
    changeEphemeral: 'Byt efemär storage',
    setEphemeralTitle: 'Sätt appernas efemära storage',
    changeEphemeralTitle: 'Byt appernas efemära storage',
    ephemeralStorageHint: 'Klustrets STANDARD: dir-lik pool där varje apps efemära rooter och volymer bor, om inte appen deklarerar en override. Ett byte tillämpas inte i varmt läge och startar inte om något: det gäller från varje apps nästa start — efemära data flyttas inte.',
    ephemeralPool: 'Storage-pool',
    ephemeralOverride: 'Efemär storage (override per app)',
    ephemeralOverrideInherit: 'Ärver klustrets standard',
    ephemeralOverrideInheritNamed: 'Ärver klustrets standard ({name})',
    ephemeralOverrideHint: 'Per-app-pool för efemära rooter och volymer — lämna tomt för att ärva klustrets standard. Ett byte tillämpas inte i varmt läge och startar inte om något: det gäller från nästa start (efemära data återfödda tomma på den nya poolen) och kräver behörigheten app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Alla brancher',
    imageBranchHint: 'Begränsar avbilderna till dem denna branch namnger; utan branch ser du alla repositoryts avbilder.',
    imageDigestHint: 'Innehållet: väljs ur digest-tabellen, som bär dess härkomst och dess arkitektur. Samma branch erbjuder ett per arkitektur, och de är inte utbytbara.',
    imageLockfile: 'Upplöst referens',
    imageNoImages: 'Ingen avbild i cachen för detta repository — hämta en från OCI-avbilder.',
    imageHeadNotCached: 'inte i cachen — hämtas vid start',
    imageNoRegistries: 'Inget repository registrerat: registrera ett för att kunna välja en avbild.',
    imageChosenHint: 'Avbilden väljs i kaskaden i redigeringsdialogen: referensen skrivs aldrig för hand.',
    registerRepositoryHint: 'Att registrera hämtar ingenting: det gör ett repository observerbart, så att avbilden kan väljas utan att lämna dialogen.',
    registerRepositoryBranchHint: 'Valfritt: den första branchen att observera (t.ex. latest).',
    registerRepositoryElsewhere: 'Repositoryt du söker är inte registrerat: registreringen sker i avsnittet OCI-avbilder, av någon som har behörigheten.'
  },
  cts: {
    createAction: 'Skapa CT',
    createTitle: 'Skapa en container från en template',
    createError: 'Containern skapades inte',
    template: 'CT-template',
    noTemplates: 'Ingen CT-template — importera en från CT-templates',
    resources: 'Resurser',
    node: 'Nod',
    phase: {
      defined: 'Aldrig påslagen',
      materializing: 'Materialiseras',
      ready: 'Redo',
      starting: 'Startar',
      running: 'Körs',
      stopping: 'Stoppas',
      stopped: 'Stoppad',
      deleting: 'Tas bort',
      error: 'I feltillstånd'
    },
    actions: {
      start: 'Starta',
      stop: 'Stoppa',
      restart: 'Starta om',
      markTemplate: 'Befordra till CT-template',
      error: 'Åtgärden avvisades'
    },
    markTemplate: {
      confirmTitle: "Befordra '{name}' till CT-template?",
      confirmBody: 'Containern lämnar den här listan och flyttar till CT-templates, direkt redo att generera nya CT. Metadatan förblir redigerbar, och du kan göra om den till CT när som helst.',
      confirm: 'Befordra',
      moved: "'{name}' är nu en CT-template — du hittar den under CT-templates."
    },
    stopCause: {
      api: 'Stoppad av TVirt',
      'ct-exit': 'Containern avslutades av sig själv',
      'host-reboot': 'Dog med nodens omstart',
      'start-failed': 'Starten misslyckades — taskens fel säger vad som saknas och hur det fixas'
    },

    console: 'Konsol',
    consoleUnavailable: 'Containern körs inte — en konsol behöver en levande container. Dess logg går däremot att läsa i vilket tillstånd som helst.',
    consoleNoTemplate: 'En template körs aldrig och har därför ingen konsol: skapa en CT från den och öppna dess konsol.',
    consoleConnect: 'Anslut',
    consoleDisconnect: 'Koppla från',
    consoleReconnect: 'Återanslut',
    consoleTakenBy: 'En annan operatör har tagit den här konsolen ({user}). En konsol per container: återansluter du tar du tillbaka den.',
    consoleHint: 'Klicka på den svarta rutan och skriv: tangenterna når containern. Ctrl+C och piltangenterna fungerar.',
    consoleEndpointDown: 'Konsolens åtkomstpunkt kan inte öppnas på noden som betjänar containern: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Containern körs inte — ett shell behöver en levande container. Dess loggar kan läsas i vilket tillstånd som helst.',
    shellNoTemplate: 'En template körs aldrig, så den har inget shell: skapa en CT från den och öppna dess.',
    shellConnect: 'Anslut',
    shellDisconnect: 'Koppla från',
    shellExited: 'Sessionen avslutades med exit-kod {code}.',
    shellEndedWithoutStatus: 'Sessionen avslutades utan exit-status: {reason}',
    shellRevoked: 'Sessionens ticket är inte längre giltig — den gick ut, eller inloggningen som öppnade den återkallades.',
    shellHint: 'Klicka i den svarta rutan och skriv: tangenterna går till containern. Ctrl+C och pilarna fungerar; exit stänger shellet.',
    shellStatus: {
      connecting: 'Ansluter…',
      connected: 'Ansluten',
      ended: 'Avslutad'
    },
    rootPassword: 'Root-lösenord',
    rootPasswordHint: 'Skrivs en gång in i det kopierade rootfs (som hash, visas aldrig igen). Distributionernas images har inget root-lösenord: utan det är shellet den enda vägen in.',
    sshKeys: 'Publika SSH-nycklar för root',
    sshKeysHint: 'En publik OpenSSH-nyckel per rad, i root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Ansluter…',
      connected: 'Ansluten',
      reconnecting: 'Återansluter…'
    },
    logs: 'Logg',
    logsTitle: 'Logg',
    logsEmpty: 'Ingen output fångad.',
    logsSource: 'Vilken logg',
    logsSourceConsole: 'Containerns init-konsol — varför tjänsten därinne inte startade',
    logsSourceSupervisor: 'liblxc-övervakaren — varför containern aldrig ens kom igång',
    logsNeverStarted: 'Den har aldrig startats, så det finns ännu inget loggat — starta den, så finns loggen där även om starten misslyckas.',
    logsNoTemplate: 'En template körs aldrig och har därför aldrig loggat något.',
    logsError: 'Loggen kunde inte fångas',

    tabs: {
      general: 'Allmänt',
      hardware: 'Maskinvara',
      network: 'Nätverk',
      provenance: 'Ursprung'
    },
    templateFlag: 'CT-template',
    templateLock: 'Ändras bara med åtgärderna Befordra / Gör om till CT — aldrig en direkt ändring.',
    sourceLock: 'Ursprung, registrerat vid födseln — aldrig omskrivet; en död källa lämnar referensen naken.',
    storageLock: 'Fastslagen vid skapandet — flytt av rootfs är en framtida runda.',
    startedAt: 'Startad',
    lastStop: 'Senaste stopp',
    editNicsTitle: 'Redigera nätverk',
    nicDisconnected: 'frånkopplad'
  },
  ctTemplates: {
    title: 'CT-templates',
    importAction: 'Importera från katalog',
    importTitle: 'Importera CT-template från katalogen',
    importSubmit: 'Importera',
    importError: 'Importen avvisades',
    importHint: 'Materialiseringen kopierar rootfs:en till den valda storagen — katalogfilen förblir intakt. För att lägga till nya filer, ladda först upp dem i en katalog.',
    sourceFile: 'CT-template-fil',
    sourceFileHint: 'Den valda katalogens ct-rootfs-filer, bara de färdiga',
    noFiles: 'Ingen färdig ct-rootfs-fil i den här katalogen — ladda upp en från katalogens sida',
    source: 'Källfil',
    rootfsStorage: 'Storage för rootfs',
    rootfsStorageHint: "Där det extraherade rootfs-trädet bor — en storage med filsystem och tillräckligt med ledigt utrymme för den extraherade storleken plus ungefär 1 GiB marginal (annars misslyckas importen).",
    resources: 'Resurser',
    cores: 'vCPU',
    memoryMiB: 'Minne (MiB)',
    cpuLimit: 'CPU-gräns',
    cpuLimitHint: 'Motsvarigheter i host-kärnor (t.ex. 1.5); tomt = utan tak',
    cpuUncapped: 'utan tak',
    cpuWeight: 'CPU-vikt',
    hostname: 'Hostname',
    hostnameHint: 'Tomt = CT:ns namn',
    nameservers: 'DNS-nameservrar',
    dnsHint: 'Kommaseparerade; tomt = ärver hostens',
    searchDomains: 'DNS-sökdomäner',
    dnsInherited: 'Ärvt från hosten',
    networks: 'Nätverk',
    nicSlot: 'NIC-slot',
    phase: {
      materializing: 'Materialiseras',
      ready: 'Redo',
      deleting: 'Tas bort',
      error: 'Fel'
    },
    exportAction: 'Exportera till katalogen',
    exportTitle: 'Exportera till katalogen',
    exportSubmit: 'Exportera',
    exportError: 'Exporten avvisades',
    exportHint: 'Paketerar den materialiserade rootfs:en i en NY ct-rootfs-fil i den valda katalogen — templaten förblir intakt.',
    exportName: 'Filnamn',
    exportNameHint: 'Tomt = <template>-export-<n>',
    markCt: {
      action: 'Gör om till CT',
      confirmTitle: "Göra om '{name}' till CT?",
      confirmBody: 'Templaten lämnar den här listan och återvänder till CT-listan, åter startbar. Tills du befordrar den igen kan inga CT skapas från den.',
      confirm: 'Gör om till CT',
      moved: "'{name}' är åter en CT — du hittar den i CT-listan."
    }
  },
  oci: {
    registriesTitle: 'OCI-registries',
    imagesTitle: 'OCI-avbilder',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generisk',
    providerImmutableHint: 'Providern är oföränderlig efter skapandet — en annan provider är ett nytt registry.',
    url: 'URL',
    urlHintPreset: 'Förifylld från providern — skriv bara över för mirrors.',
    urlHintRequired: 'Obligatorisk för generiska registries: bas-URL:en https://.',
    urlHintEcr: 'Obligatorisk: ECR-endpoints är per konto/per region — det finns ingen preset.',
    credential: 'Autentiseringsuppgift',
    credentialNone: 'Anonym åtkomst',
    credentialHint: 'En keystore-post med användarnamn och lösenord; workrarna löser den vid användningen — aldrig auth-filer per nod.',
    nameHint: 'Host-likt namn (docker.io, registry.intra); unikt per scope, oföränderligt',
    addRegistry: 'Lägg till registry',
    addRegistryTitle: 'Lägg till OCI-registry',
    verify: 'Verifiera',
    verifyState: 'Verifiering',
    verified: 'Verifierat',
    verifyFailed: 'Misslyckades',
    neverVerified: 'Aldrig verifierat',
    registryInUseError: "'{name}' har fortfarande registrerade repositories — radera dem först.",
    repositories: 'Repositories',
    repositoriesHint: 'Att registrera observerar brancherna (OCI-taggar) — det laddar inte ner något. Refreshen löser varje observerad branch och för reflogen.',
    noRepositories: 'Inget repository registrerat på det här registryt.',
    registerRepository: 'Registrera repository',
    repoPath: 'Sökväg',
    repoPathHint: "Repositoryts sökväg på registryt, t.ex. 'example' eller 'library/nginx'",
    branches: 'Brancher',
    branchesHint: 'Observerade brancher (OCI-taggar), kommaseparerade — t.ex. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Löst NU: pullen laddar ner den digest som branchen pekar på i dag.',
    refresh: 'Uppdatera',
    deleteRepository: 'Radera repository',
    reflogCount: '{n} tidigare',
    noResolutions: 'Aldrig uppdaterat — ingen upplösning observerad.',
    refreshFailed: 'Senaste uppdateringen misslyckades ({when})',
    loadError: 'Kunde inte läsa in repositoryerna.',
    reference: 'Referens',
    digest: 'Digest',
    digestHint: 'sha256:… — den exakta avbilden, utan branch (detached)',
    size: 'Storlek',
    nodes: 'Noder',
    detached: 'detached',
    detachedHint: 'Nedladdad per digest, utan branch — driftkontrollen gäller inte.',
    pulledAt: 'Nedladdad',
    pull: 'Pull',
    pullTitle: 'Pulla avbild',
    pullHint: 'Förvärmning, aldrig en förutsättning: en pull per branch löser NU och laddar ner DEN digesten; en pull per digest är detached.',
    pullError: 'Pullen avvisades',
    pullMode: 'Pull per',
    pullModeBranch: 'Branch (lös nu)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Den ärliga standarden: som apt install — körd igen senare kan den ge en annan avbild.',
    pullModeDigestHint: 'Exakt digest — reproducerbarhet och rollback; avstår från driftkontrollen.',
    importFromRegistry: 'Importera från registry',
    importFromCatalog: 'Importera från katalog',
    importCatalogTitle: 'Importera OCI-avbild från katalog',
    importCatalogHint: 'Den air-gappade vägen: ett färdigt oci-image-arkiv (tar/tar.gz — docker-archive eller oci-archive) materialiseras i avbildslagret med referensen catalog/<katalog>/<fil>@<digest>; apparna konsumerar den som vilken annan avbild som helst. Arkiven laddas upp i katalogerna — den här sektionen importerar och inget mer.',
    importCatalogFile: 'Arkiv',
    importCatalogFileHint: 'Den valda katalogens färdiga oci-image-filer.',
    importCatalogNoFiles: 'Inget färdigt oci-image-arkiv i den här katalogen — ladda upp ett från katalogdetaljen.',
    importCatalogError: 'Importen avvisades',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'Klustrets OCI-cache är inte konfigurerad — pulls avvisas tills du sätter en storage-pool.',
    setCache: 'Sätt cache',
    setCacheTitle: 'Konfigurera OCI-cachen',
    setCacheHint: 'Den STANDARD-pool på klusternivå som huserar de nedladdade avbildernas blobbar — ett scope kan göra override med sin egen pool (sidan Scope). Ett byte tillämpas inte i varmt läge och startar inte om något, och det flyttar inte blobbarna: de dyker upp lazy igen vid nästa start/användning.',
    cachePool: 'Storage-pool',
    changeCache: 'Byt cache',
    changeCacheTitle: 'Byt OCI-cachens pool',
    cacheCurrent: 'Klustrets OCI-cache (standard): {name}',
    sectionOverview: 'Översikt',
    sectionRepositories: 'Repositories',
    sectionExplore: 'Utforska',
    exploreHint: 'Live fjärrsökning på registryt — Docker Hub fullt ut (beskrivning, nedladdningar, stjärnor), andra providers best-effort. Välj ett resultat för att läsa dess fullständiga beskrivning och bläddra bland dess fjärrtaggar; från en tagg kan du lägga till referensen i ett TVirt-repository.',
    exploreSearch: 'Sök',
    exploreUnsupported: 'Den här providern stöder inte sökning.',
    exploreNoResult: 'Inget matchande repository.',
    exploreNoTags: 'Ingen matchande tagg på det här repositoryt.',
    exploreOfficial: 'Officiell',
    explorePulls: 'Nedladdningar',
    exploreStars: 'Stjärnor',
    exploreUpdated: 'Uppdaterad {when}',
    exploreLoadMore: 'Läs in fler',
    exploreSelectHint: 'Välj ett resultat: fullständig beskrivning och fjärrtaggar läses in här.',
    exploreNoDescription: 'Ingen beskrivning tillgänglig från den här providern.',
    exploreTagsTitle: 'Fjärrtaggar',
    exploreTagFilter: 'Sök tagg',
    exploreAddToRepo: 'Lägg till i repository',
    exploreAdded: '{path}:{tag} spåras nu — se sektionen Repositories.',
    addBranch: 'Lägg till branch',
    purgeRequiredTitle: "Radera '{name}' och dess avbilder?",
    purgeRequiredBody: 'Ingen app använder detta repository, men nedladdade avbilder finns kvar: radering tar också bort deras poster, och de cachade blobbarna går till garbage collection.',
    purgeConfirm: 'Radera även avbilderna',
    providerSelectHint: 'Välj registry-typ: kortet berättar preset och användning.',
    providerDesc: {
      dockerhub: 'Det publika Docker-registryt: URL förifylld, full sökning med beskrivningar och räknare.',
      ghcr: 'GitHub Container Registry: URL förifylld; konton använder ett personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpoints per konto/region — URL:en måste anges.',
      quay: 'Red Hat Quay-registryt: URL förifylld.',
      generic: 'Self-hostat registry (Harbor, registry:2, …): https://-URL:en är obligatorisk.'
    },
    layerCount: 'Layers',
    verifiedAt: 'Senaste verifiering',
    verifyOk: 'Utfall',
    verifyMessage: 'Verifieringsmeddelande',

    // Modellen #348/R39: avbilden ÄR digesten — innehållet — och registry, repository och branch är NAMNEN som når den.
    head: 'Head',
    heads: 'Heads per arkitektur',
    listDigest: 'Listans digest',
    neverResolved: 'Aldrig upplöst',
    totalSize: 'Total storlek',
    reflogTitle: 'Upplösningshistorik',
    usedBy: 'Används av',
    usageLockfile: 'lockfile',
    usageRunning: 'körs',
    evictable: 'kan tas bort',
    evict: 'Ta bort från cachen',
    evictHeadTitle: 'Ta bort {digest}?',
    evictHeadBody: 'Det är den aktuella upplösningen för minst en samlare: att ta bort den är legitimt — det är bara cache, den fjärran branchen levererar den fortfarande — men det får aldrig ske av misstag. Bloben är EN: borttagningen tömmer alla samlare som delar den.',
    evictConfirm: 'Ta bort den ändå',

    arch: 'Arkitektur',
    names: 'Namn',
    noNames: 'inget namn',
    views: 'Vyer',
    lastView: 'sista vyn',
    evictLastViewTitle: 'Ta bort den sista referensen till {digest}?',
    evictLastViewBody: 'Detta är den sista vyn på innehållet: tar du bort den upphör avbilden att finnas på TVirt och byten ({size}) frigörs. Det är modellens docker image rm — ingen sidoeffekt, utan själva operationen.',
    branchesTabHint: 'De observerade brancherna i detta repository: för var och en dagens heads — en per arkitektur — kronologin över uppdateringarna och hur många av avbilderna den namngett som finns i cachen. Uppdateringen är repositoryts «git fetch»: den löser upp alla dess brancher på en gång.',
    noBranches: 'Ingen branch observeras i detta repository.',
    stopObserving: 'Sluta observera branchen',
    pullBranch: 'Hämta branchens head till cachen (refresh löser upp, denna laddar ner)',
    pullDigest: 'Hämta denna digest till cachen',
    imageCount: 'Avbilder',
    deleteBranchPurgeTitle: 'Lämna avbilderna i {name} utan namn?',
    deleteBranchPurgeBody: 'Ingen app namnger denna branch, men vissa avbilder nås bara via den: tar du bort den blir de kvar i cachen utan namn, listade bland repositoryts avbilder och möjliga att rensa för hand.',
    deleteBranchPurgeConfirm: 'Ta bort och lämna avbilderna utan namn',
    imagesTabHint: 'Avbilderna i detta repository — innehållet, alltså digesterna — synliga även utan att välja en branch. En avbild är unik per kluster: namnen som når den kan vara flera.',
    noImages: 'Ingen avbild i detta repository är materialiserad i cachen.',
    deleteRepositoryTitle: 'Ta bort {name}?',
    deleteRepositoryBody: 'Repositoryt och dess brancher försvinner, med sin kronologi. Avbilderna blir kvar i cachen: de förlorar bara detta namn. Ett repository som en app namnger går inte att ta bort.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Uppdaterad',
    neverRefreshed: 'Aldrig uppdaterad',
    sectionBranches: 'Brancher',
    sectionImages: 'Avbilder',
    repositoriesGovernedElsewhere: 'Här betraktas repositoryn bara: att registrera dem, uppdatera dem, observera deras brancher och rensa deras avbilder sker i avsnittet OCI-avbilder.',
    gotoImages: 'Gå till OCI-avbilder'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Containrar',
    instances: 'Instanser',
    instancesTooltip: '{running} körs, {error} i fel',
    placement: 'Placering',
    spread: 'spridning',
    ha: 'HA',
    templateRevision: 'revision',
    deleting: 'Tas bort',
    empty: 'Inga pods — skapa en app (en container) eller en pod från CLI (create-pod).',
    openInstances: 'Öppna instanserna',
    rollingRestart: 'Rullande omstart',
    scale: 'Skala',
    scaleTitle: 'Skala {name}',
    scaleHint: 'Antal instanser (0–64): uppåt fylls det lägsta lediga ordningstalet, nedåt dras det högsta tillbaka och dess beständiga data behålls.',
    scaleError: 'Skalningen misslyckades',
    replicas: 'Repliker',
    deleteRunningError: '{name} körs — stoppa den först.',
    deleteInstancesIntro: 'Alla {count} instanser tas bort.',
    stateRunning: 'Körs',
    stateStopped: 'Stoppad',
    editor: {
      createTitle: 'Skapa Pod',
      create: 'Skapa Pod',
      editTitle: 'Redigera Pod',
      nameHint: 'DNS-1123, högst 58 tecken — instanserna heter <namn>-<index>; oföränderligt efter skapandet.',
      restartPolicy: 'Omstartspolicy',
      restartPolicyHint_always: 'Noden startar om varje avslutad container, med exponentiell backoff (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Bara en container som avslutas med annat än noll startas om; avslut 0 vilar.',
      restartPolicyHint_never: 'En avslutad container lämnas som den är — instansen slutar som succeeded eller failed.',
      grace: 'Frist (s)',
      graceHint: 'SIGTERM → SIGKILL-gränsen för ett stopp.',
      hostname: 'Värdnamn',
      hostnameHint: 'Tomt = instansens namn.',
      hostnameDefault: 'instansens namn',
      sharePid: 'Dela PID-namnrymd mellan containrarna',
      containersIntro: 'Init-containrar körs till slut, i ordning, innan containrarna startar; containrarna delar instansens nätverk (en IP, localhost sinsemellan).',
      initContainers: 'Init-containrar',
      initAdd: 'Lägg till init-container',
      initHint: 'Var och en måste avslutas med 0; ett misslyckande sätter instansen i fel och noden försöker igen med backoff.',
      containerAdd: 'Lägg till container',
      atLeastOne: 'En Pod behöver minst en container.',
      duplicateNames: 'Containernamn måste vara unika inom Podden (init-containrar inräknade).',
      containerName: 'Containernamn',
      containerInvalid: 'Den här containern är ofullständig: namn (DNS-1123), avbild, monteringar på deklarerade volymer, numeriska gränser och sond.',
      command: 'Kommando',
      commandHint: 'Åsidosätter avbildens entrypoint — ett argument per rad, aldrig en skalsträng.',
      args: 'Argument',
      argsHint: 'Ett per rad (avbildens CMD om tomt).',
      mounts: 'Monteringar',
      mountAdd: 'Lägg till montering',
      mountNoVolumes: 'Deklarera först en volym under fliken Lagring.',
      readOnly: 'skrivskyddad',
      resources: 'Gränser',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (t.ex. 1.5)',
      memory: 'Minne (MiB)',
      memoryHint: 'podman --memory',
      health: 'Livsprob',
      healthCmd: 'Probkommando',
      healthCmdHint: 'Körs i containern av noden vid varje övervakningstick — ett argument per rad; avslut 0 = frisk.',
      healthTimeout: 'Tidsgräns (s)',
      healthRetries: 'Försök',
      healthRetriesHint: 'Efterföljande misslyckanden innan noden startar om containern.',
      ips: 'Statiska adresser',
      ipsHint: 'En per instans, i ordningsföljd — skalning bortom listan avvisas.',
      instance: 'instans',
      volumesHint: 'Volymerna är Poddens; monteringsvägen är varje containers (fliken Containrar).',
      spread: 'Spridning',
      spreadHint_preferred: 'Instanser på olika noder när det går.',
      spreadHint_required: 'Instanser på olika noder, annars avvisar skalningen.',
      spreadHint_none: 'Bara beslutaren.',
      ha: 'Hög tillgänglighet (opt-in)',
      haHint: 'Varje beständig del på delad lagring; om noden dör återskapar HA-decidern instanserna på en annan medlem (automatisk failover, som HA-VM:er).',
      yes: 'ja',
      no: 'nej'
    },
    detail: {
      container: 'Container',
      actions: 'Åtgärder',
      ready: 'Redo',
      notReady: 'Inte redo',
      restarts: 'Omstarter',
      lastRestartAt: 'Senaste omstart:',
      backoffUntil: 'Nytt försök kl.',
      stateAbsent: 'saknas',
      stateRunning: 'kör',
      stateTerminated: 'avslutad',
      stateWaiting: 'väntar',
      init: 'init',
      noInstances: 'Inga instanser (repliker 0).',
      ha: 'HA',
      haHint: 'Automatisk failover: om noden dör återskapar HA-decidern instansen på en annan medlem (varje beständig del på delad lagring).',
      authority: 'Authority (nod)',
      homeless: 'utan authority',
      homelessHint: 'En återställning från checkpoint utelämnar authority (#380): ingen nod betjänar den förrän du skalar Podden (även till samma antal repliker).',
      restartContainer: 'Starta bara om den här containern (podden är kvar)',
      divergingHint: 'Den här instansens önskade tillstånd avviker från Poddens standard (PD-P19).',
      revisionLag: 'revision {applied} tillämpad av {current}',
      updatedInstances: '{updated}/{desired} instanser på denna revision'
    }
  }
}
